import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import * as routes from '../../../constants/routes';
import { required } from '../../../utils/validation';
import { FormikFieldRenderProps } from '@troy/shared/src/types/formik';
import {
  ActionButton,
  Translation,
  TextInput,
  CustomLink
} from '@troy/shared/src/components/common';

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  email: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  password: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  loginButton: {
    width: `calc(100% - ${theme.spacing(4)})`
  },
  forgotPassword: {
    marginTop: theme.spacing(4),
    whiteSpace: 'pre',
    textAlign: 'center',
    letterSpacing: '0.6px'
  }
}));

interface LoginFormProps {
  onSubmit: (values: { email: string; password: string }) => void;
}

const Email: React.FC<FormikFieldRenderProps> = ({
  field: { name, value, onChange }
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <TextInput
      className={classes.email}
      id="login-form-email"
      placeholder="Email"
      inputPlaceholder="ALL_UXCOPIES_PLACEHOLDER_EMAIL"
      startIcon="profile"
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

const Password: React.FC<FormikFieldRenderProps> = ({
  field: { name, value, onChange }
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <TextInput
      className={classes.password}
      id="login-form-password"
      placeholder="PASSWORD"
      inputPlaceholder="ALL_UXCOPIES_PLACEHOLDER_PASSWORD"
      startIcon="key"
      type="password"
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit }) => {
  const classes = useStyles();

  return (
    <Formik
      validateOnMount
      initialValues={{ email: '', password: '' }}
      onSubmit={onSubmit}
    >
      {({ isValid }): JSX.Element => (
        <Form className={classes.form}>
          <Field name="email" component={Email} validate={required} />
          <Field name="password" component={Password} validate={required} />
          <ActionButton
            id="login-form-submit-button"
            type="submit"
            padding="medium"
            className={classes.loginButton}
            disabled={!isValid}
          >
            <Translation isFragment>LOGIN</Translation>
          </ActionButton>
          <CustomLink
              className={classes.forgotPassword}
              id="login-form-forgot-password"
              to={routes.FORGOT_PASSWORD}
              typography="body2"
              variant="primary"
          >
            <Translation keyIfNoValue isFragment>
              UNIC_UXCOPIES_PASSWORD_RESET
            </Translation>
          </CustomLink>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
